import React, { useEffect } from 'react'
import {
	BrowserRouter as Router,
	Routes,
	Route,
	Navigate,
} from 'react-router-dom'

import HomePage from './pages/HomePage'
import ExperienceSearchPage from './pages/ExperienceSearchPage'
import CheckInDetailPage from './pages/CheckInDetailPage'
import SuccessPage from './pages/SuccessPage'
import CheckInPassPage from './pages/CheckInPassPage'
import LoginPage from './pages/LoginPage'
import ManageUsersPage from './pages/ManageUsersPage'
import ManageExperiencesPage from './pages/ManageExperiencesPage'
import EditUserPage from './pages/EditUserPage'
import ManageStaffPage from './pages/ManageStaffPage'
import EditStaffPage from './pages/EditStaffPage'
import ManageCheckInsPage from './pages/ManageCheckInsPage'
import EditCheckInPage from './pages/EditCheckinPage'
import EditExperienceDetailsPage from './pages/EditExperienceDetailsPage'
import CheckInOverviewPage from './pages/CheckInOverviewPage'
import NotFoundPage from './pages/NotFoundPage'

import PrivateRoute from './components/PrivateRoute'
import AdminRoute from './components/AdminRoute'
import OwnerRoute from './components/OwnerRoute'

import PrivateLayout from './layouts/PrivateLayout'
import PublicLayout from './layouts/PublicLayout'

import 'bootstrap/dist/css/bootstrap.min.css'
import ResetPasswordPage from './pages/ResetPasswordPage'

const App = () => {
	useEffect(() => {
		const refreshInterval = setInterval(async () => {
			const token = localStorage.getItem('token')
			if (token) {
				try {
					await fetch('/api/auth/refresh', {
						method: 'POST',
						headers: {
							Authorization: `Bearer ${token}`,
						},
					})
				} catch (error) {
					console.error('Error refreshing session', error)
					localStorage.removeItem('token')
					window.location.href = '/login'
				}
			}
		}, 10 * 60 * 1000)

		return () => clearInterval(refreshInterval)
	}, [])

	return (
		<Router>
			<Routes>
				{/* Public layout */}
				<Route element={<PublicLayout />}>
					<Route path='/login' element={<LoginPage />} />
					<Route path='/get-pass/:id' element={<CheckInPassPage />} />
					<Route path='/reset-password' element={<ResetPasswordPage />} />
				</Route>

				{/* Private layout + protection */}
				<Route
					element={
						<PrivateRoute>
							<PrivateLayout />
						</PrivateRoute>
					}
				>
					{/* Basic private routes */}
					<Route index element={<HomePage />} />
					<Route
						path='experiences/:experienceSlug'
						element={<ExperienceSearchPage />}
					/>
					<Route
						path='experiences/:experienceSlug/search'
						element={<Navigate to='/' replace />}
					/>
					<Route
						path='experiences/:experienceSlug/checkIn/:id'
						element={<CheckInDetailPage />}
					/>
					<Route
						path='experiences/:experienceSlug/success'
						element={<SuccessPage />}
					/>
					<Route
						path='experiences/:experienceSlug/manage/checkin/:id'
						element={<EditCheckInPage />}
					/>

					{/* Admin-only routes */}
					<Route
						path='admin/users'
						element={
							<AdminRoute>
								<ManageUsersPage />
							</AdminRoute>
						}
					/>
					<Route
						path='admin/experiences'
						element={
							<AdminRoute>
								<ManageExperiencesPage />
							</AdminRoute>
						}
					/>
					<Route
						path='admin/users/:userId/edit'
						element={
							<AdminRoute>
								<EditUserPage />
							</AdminRoute>
						}
					/>
					<Route
						path='experiences/:experienceSlug/manage/details'
						element={
							<AdminRoute>
								<EditExperienceDetailsPage />
							</AdminRoute>
						}
					/>

					{/* Owner-only routes */}
					<Route
						path='experiences/:experienceSlug/manage/staff'
						element={
							<OwnerRoute>
								<ManageStaffPage />
							</OwnerRoute>
						}
					/>
					<Route
						path='experiences/:experienceSlug/manage/staff/:staffId/edit'
						element={
							<OwnerRoute>
								<EditStaffPage />
							</OwnerRoute>
						}
					/>
					<Route
						path='experiences/:experienceSlug/manage/checkins'
						element={
							<OwnerRoute>
								<ManageCheckInsPage />
							</OwnerRoute>
						}
					/>
					<Route
						path='experiences/:experienceSlug/overview'
						element={
							<OwnerRoute>
								<CheckInOverviewPage />
							</OwnerRoute>
						}
					/>
				</Route>
				<Route path='*' element={<NotFoundPage />} />
			</Routes>
		</Router>
	)
}

export default App
